import Script from "next/script";
import settings from "src/settings";
import styled from "styled-components";
const { GAME_UID } = settings;

const NavContainer = styled.div`
  width: 100%;

  .tab-container {
    display: none;
  }

  .site-footer {
    z-index: unset;
  }
`;

function NascarNav() {
  return (
    <>
      <Script
        id={`${GAME_UID}-nascar-footer`}
        key={`${GAME_UID}-nascar-footer`}
        type="text/javascript"
        src="https://www.nascar.com/wp-content/themes/ndms-2023/inc/nav/thirdPartyFooter.js?v=1.8570"
        strategy="afterInteractive"
        footer-root-id="nascarFooter"
      />
      <NavContainer id="nascarFooter" />
    </>
  );
}
export default NascarNav;
